export default "__VITE_ASSET__DnVqOOvd__"